import { Modal } from "react-bootstrap";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";

export interface DeleteModalProps {
    show: boolean;
    id: string;
    onDelete: (id: string) => void;
    onHide: () => void;
    label: string;
}


const DeleteModal = ({ show, id, onDelete, onHide, label }: DeleteModalProps) => {
    return (
        <ThemedModal centered show={show} onHide={onHide} backdrop="static">
            <Modal.Header className="bg-secondary text-white" closeButton>
                <StyledModalTitle>Delete {label}</StyledModalTitle>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete this {label.toLocaleLowerCase()}?
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary text-white" onClick={onHide}>
                    Cancel
                </button>
                <button
                    className="btn btn-danger"
                    onClick={() => {
                        onDelete(id);
                        onHide();
                    }}
                >
                    Delete
                </button>
            </Modal.Footer>
        </ThemedModal>
    );
};

export default DeleteModal;